import * as React from 'react'

import {InternalServerErrorPage} from '@invitae/ssr-core'

const Custom500: React.FC = () => <InternalServerErrorPage />

export default Custom500
